import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ProformaService } from '../proforma.service';

@Component({
    selector: 'app-proforma-copy-form',
    templateUrl: './proforma-copy-to-form.component.html',
    styleUrls: ['./proforma-copy-to-form.component.css'],
    standalone: false
})
export class ProformaCopyToFormComponent implements OnInit {
  	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage;
	proforma;
	@Output() doProformaCopied = new EventEmitter<any>();

  validationMessages =
		{
			name: [{ type: 'required', message: 'New name is required.' }],
		};


  constructor(private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		public proformaService : ProformaService,
		public dynamicDialogRef: DynamicDialogRef,
		public dynamicDialogConfig: DynamicDialogConfig) { 

		}

	@Output() doCopy = new EventEmitter<any>();

  ngOnInit(): void {
	if (this.dynamicDialogConfig.data) {
		// get the proforma
		this.proforma = this.dynamicDialogConfig.data.proforma;
	}
	//this.proforma = this.dynamicDialogConfig?.data?.proforma
		this.buildForm();

  }
  onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		let copiedProformaName = this.proforma.name;
		this.proforma.name = this.form1.value.name;
		try {
			// if(this.proforma.realtorProfileId == undefined){
			// 	return;
			// }
			this.formLoading = true;
			this.proformaService.copyTo(this.proforma)
				.subscribe(
					res => {
						console.log('Response Of Copy Proforma: ' + JSON.stringify(res));
						this.messageService.add({
							severity: "success",
							summary: "Success",
							detail: copiedProformaName + ' Copied',
						});
						//this.proforma = res.data.proforma;
						//return this.proforma;

						//this.doCopy.emit(this.proforma);
						setTimeout( ()=>{
							this.formLoading = false;
							this.doProformaCopied.emit(res.data.proforma);
							this.dynamicDialogRef.close(res.data.proforma);
						}, 2000)
						
					 // return;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					//	this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			//this.alertService.error(error);
		}
		// this.dynamicDialogRef.close(this.form1.value);
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			//rateBucketId: [this.rateBucket.rateBucketId],
			proformaId: [this.proforma.proformaId],
			name: ['', Validators.required],
		});
	}

}
